import React from "react";

import { Route, Switch, useRouteMatch, Redirect } from "react-router-dom";

import Students from "./Students";

const StudentsRouter = React.memo(() => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <Students />
      </Route>
      <Redirect to={path} />
    </Switch>
  );
});

export default StudentsRouter;
